import React from 'react';
import { Link } from 'react-router-dom';
const legalLinks = [{
  label: 'Privacy Policy',
  to: '/privacy-policy'
}, {
  label: 'Terms of Service',
  to: '/terms-and-conditions'
}, {
  label: 'Cookie Policy',
  to: '/cookie-policy'
}, {
  label: 'Do Not Sell My Info',
  to: '/do-not-sell-my-info'
}];
interface LegalLinksProps {
  /** Alignment within the footer that hosts it. */
  align?: 'left' | 'center';
  className?: string;
}

/**
 * OnlineCollegeGuide's legal links as a compact row, for dropping into a
 * partner school's own branded footer. Every page must expose these, but the
 * school footers carry the school's branding, so this is the shared row rather
 * than a second full footer.
 */
export function LegalLinks({
  align = 'left',
  className = ''
}: LegalLinksProps) {
  const scrollToTop = () => window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
  return <nav aria-label="Legal" className={className} data-id="element-687" data-mp="31xnz0ymq1oox">
      <ul className={`flex flex-wrap items-center gap-x-4 gap-y-2 ${align === 'center' ? 'justify-center' : ''}`} data-id="element-688" data-mp="2x04hnpuq8vsr">
        {legalLinks.map(link => <li key={link.to} data-id="element-689" data-mp="1hvbqecsv2wrd">
            <Link to={link.to} onClick={scrollToTop} className="text-xs text-gray-500 hover:text-gray-900 hover:underline transition-colors" data-id="element-690" data-mp="1huk6hz8mmngx">
              {link.label}
            </Link>
          </li>)}
      </ul>
    </nav>;
}